import { useNavigate } from 'react-router';

import { BlacklineTable } from './table';

export function Blackline() {
	const nav = useNavigate();
	
	 return (
		<>
			<div>
				<h1 className="mb-4 text-center text-2xl font-semibold">
					Blackline
				</h1>
			</div>
			<div className="mb-4 flex justify-end">
				
			</div>
				<BlacklineTable />
		</>	
	);
}
